/* tslint:disable */
/* eslint-disable */
/**
 * Xerjoff.Agenti.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClienteCreateDTO
 */
export interface ClienteCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof ClienteCreateDTO
     */
    partitaIva?: string | null;
}

/**
 * Check if a given object implements the ClienteCreateDTO interface.
 */
export function instanceOfClienteCreateDTO(value: object): value is ClienteCreateDTO {
    return true;
}

export function ClienteCreateDTOFromJSON(json: any): ClienteCreateDTO {
    return ClienteCreateDTOFromJSONTyped(json, false);
}

export function ClienteCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClienteCreateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'partitaIva': json['partitaIva'] == null ? undefined : json['partitaIva'],
    };
}

  export function ClienteCreateDTOToJSON(json: any): ClienteCreateDTO {
      return ClienteCreateDTOToJSONTyped(json, false);
  }

  export function ClienteCreateDTOToJSONTyped(value?: ClienteCreateDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'partitaIva': value['partitaIva'],
    };
}

